const CHANGE_VALUES = 'shipments/CHANGE_VALUES';
const SET_EXTRA = 'shipments/SET_EXTRA';

const changeExtras$ = 'shipments/changeExtras$';
const changeTime$ = 'shipments/changeTime$';
const selectTime$ = 'shipments/selectTime$';
const onBlurTimePicker$ = 'shipments/onBlurTimePicker$';

const changeDate$ = 'shipments/changeDate$';

const changeAddress$ = 'shipments/changeAddress$';

const setDefaults$ = 'shipments/setDefaults$';

const SET_COMMENT_FOR_TRANSPORTIST = 'shipments/SET_COMMENT_FOR_TRANSPORTIST';
const SET_INTERNAL_REFERENCE = 'shipments/SET_INTERNAL_REFERENCE';
const SET_APPOINTMENT_INSTRUCTIONS = 'shipments/SET_APPOINTMENT_INSTRUCTIONS';

const createShipment$ = 'shipments/createShipment$';
const ADD_SHIPMENT = 'shipments/ADD_SHIPMENT';

const deleteShipment$ = 'shipments/deleteShipment$';
const REMOVE_SHIPMENT = 'shipments/REMOVE_SHIPMENT';

const CLEAN_COMMENTS_AND_INTERNAL_REFERENCE =
  'shipments/CLEAN_COMMENTS_AND_INTERNAL_REFERENCE';

const prepareForRecurringQuote$ = 'shipments/prepareForRecurringQuote$';

export default {
  CHANGE_VALUES,
  SET_EXTRA,
  changeExtras$,
  changeTime$,
  selectTime$,
  onBlurTimePicker$,
  changeDate$,
  changeAddress$,
  setDefaults$,
  SET_COMMENT_FOR_TRANSPORTIST,
  SET_INTERNAL_REFERENCE,
  SET_APPOINTMENT_INSTRUCTIONS,
  createShipment$,
  ADD_SHIPMENT,
  deleteShipment$,
  REMOVE_SHIPMENT,
  CLEAN_COMMENTS_AND_INTERNAL_REFERENCE,
  prepareForRecurringQuote$,
};
